import * as React from 'react';
import * as ReactDom from 'react-dom';
import {groupBy} from 'lodash';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';

import Client from './Client';
import placeTypes from './Client/Config/placeTypes';
import {TApplicationInjectData, TRootProps} from './Client/Definitions';

export default ($root: HTMLElement) => {
	const $clientNode = $root.querySelector('[data-select="client"]') as HTMLElement|null;

	if ($clientNode) {
		const $scrollHelper = $root.querySelector('[data-select="scrollHelper"]') as HTMLElement|null;
		const googleApiKey = $clientNode.dataset.googleApiKey || '';
		const {
			categories = [],
			pois = [],
			filter = {},
			label = {},
		}: TApplicationInjectData = JSON.parse($clientNode.dataset.applicationData || '{}');

		const scrollIntoView = () => $scrollHelper &&
			scrollIntoViewIfNeeded($scrollHelper, {
				scrollMode: 'if-needed',
				behavior: 'smooth',
				block: 'start',
				inline: 'start',
			});

		// Pre-filtering (could also be happen serverside)
		// These initial data won't be change by application.
		const sortedPois = pois
			// Filter empty entries
			.filter(({name, placeId})=> Boolean(name) && Boolean(placeId))
			.sort((a, b) => a.name.localeCompare(b.name));
		const filteredPois = sortedPois
			.filter(poi => !poi.isBlacklisted && (!filter.category || poi.categories.includes(filter.category)));

		// Helper for detecting redundant place IDs.
		Object.entries(groupBy(pois, 'placeId'))
			.filter(([_, pois]) => pois.length > 1)
			.forEach(([placeId, pois]) => console.warn(`Mehrfache Nutzung der PlaceID ${placeId} für folgende POIs: ${pois.map(poi => poi.name).join(', ')}.`));

		const allowedPlaceTypes = categories
			.filter(category => !filter.category || category.key === filter.category)
			.reduce((memo, {key}) => Object.assign(memo, placeTypes[key]), {});

		const head = document.getElementsByTagName("head")[0];
		const insertBefore = head.insertBefore;
		if (head instanceof HTMLHeadElement) {
			// @ts-ignore
			head.insertBefore = function (newElement, referenceElement) {
				if (newElement instanceof HTMLLinkElement) {
					if (newElement.href && newElement.href.indexOf("//fonts.googleapis.com/css?family=") > -1) {
						return;
					}
				}
				insertBefore.call(head, newElement, referenceElement);
			};
		}

		ReactDom.render(
			React.createElement(
				Client,
				{
					googleApiKey,
					allPois: sortedPois,
					filteredPois,
					allowedPlaceTypes,
					filter: {
						hasWertkarte: filter.hasWertkarte,
						isFairTrade: filter.isFairTrade,
					},
					label,
					scrollIntoView,
				} as TRootProps,
			),
			$clientNode
		);
	}
}
